export default {
    LOAD_PUBLIC_COURSES_LIST_FAILURE: 'LOAD_PUBLIC_COURSES_LIST_FAILURE',
    LOAD_PUBLIC_COURSES_LIST_SUCCESS: 'LOAD_PUBLIC_COURSES_LIST_SUCCESS',
    LOAD_INSTITUTE_LIST_SUCCESS:'LOAD_INSTITUTE_LIST_SUCCESS',
    LOAD_DEPARTMENT_LIST_SUCCESS:'LOAD_DEPARTMENT_LIST_SUCCESS',
    LOAD_PAGINATION_INFO_SUCCESS: 'LOAD_PAGINATION_INFO_SUCCESS',

};
